import { render, staticRenderFns } from "./PrintNotaP.vue?vue&type=template&id=1610d32e&scoped=true&"
import script from "./PrintNotaP.vue?vue&type=script&lang=js&"
export * from "./PrintNotaP.vue?vue&type=script&lang=js&"
import style0 from "./PrintNotaP.vue?vue&type=style&index=0&media=print&lang=css&"
import style1 from "./PrintNotaP.vue?vue&type=style&index=1&id=1610d32e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1610d32e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VProgressLinear,VRow,VTextField})
